import contentJson from "@/services/static/data/conteudo-site.json"
import type { ContentService } from "@/services/ports"
import type { SiteContent } from "@/services/types"

const CONTENT = contentJson as SiteContent

export function createStaticContentService(): ContentService {
  return {
    async getSiteContent(): Promise<SiteContent> {
      return CONTENT
    },
  }
}
